export class EventTypeInputDelayEventTypeMap {
    constructor(
        eventTypeInputDelayEventTypeMapId: number,
        eventTypeId: number,
        eventTypeInputId: number,
        delayTimeMinutes: number,
        startDelayEventTypeId: number
    ) {
        this.eventTypeInputDelayEventTypeMapId = eventTypeInputDelayEventTypeMapId;
        this.eventTypeId = eventTypeId;
        this.eventTypeInputId = eventTypeInputId;
        this.delayTimeMinutes = delayTimeMinutes;
        this.startDelayEventTypeId = startDelayEventTypeId;
    }
    eventTypeInputDelayEventTypeMapId: number;
    eventTypeId: number;
    eventTypeInputId: number;
    delayTimeMinutes: number;
    startDelayEventTypeId: number;
}
